/* import {
  AiIcon,
  ComputerIcon,
  GamingIcon,
  MobilePhoneIcon,
  NetworkIcon,
} from '@onbeam/icons/business'; */

export const investingInSubjects = [
  {
    text: 'An Era of New Possibilities',
  },
  {
    text: 'Where Tomorrow Takes Shape',
  },
  {
    text: 'Where Innovation Becomes Reality',
  },

  /* {
    text: 'new possibilities',
  },
  {
    icon: GamingIcon,
    text: 'games',
  },
  {
    icon: AiIcon,
    text: 'AI',
  },
  {
    icon: MobilePhoneIcon,
    text: 'apps',
  },
  {
    icon: ComputerIcon,
    text: 'compute',
  },
  {
    icon: NetworkIcon,
    text: 'Web3',
  }, */
];
